import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Box,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form, Field } from 'formik';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';

// Define validation schema
const validationSchema = Yup.object().shape({
  name: Yup.string()
    .trim('')
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must not exceed 50 characters')
    .matches(
      /^[a-zA-Z0-9\s-_]+$/,
      'Name can only contain letters, numbers, spaces, hyphens and underscores'
    ),
  description: Yup.string()
    .trim('')
    .required('Description is required')
    .min(10, 'Description must be at least 10 characters')
    .max(500, 'Description must not exceed 500 characters'),
});

const CatalogueDialog = ({
  open,
  onClose,
  onSubmit,
  initialValues,
  title,
}: any) => (
  <Dialog
    onClose={onClose}
    open={open}
    fullWidth
    PaperProps={{ style: { overflow: 'hidden' } }}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        p: 2,
      }}>
      <Typography variant="h4" sx={{ display: 'inline-block' }}>
        {title}
      </Typography>

      <IconButton
        edge="end"
        color="inherit"
        onClick={onClose}
        aria-label="close">
        <CloseIcon />
      </IconButton>
    </Box>
    <DialogContent style={{ padding: '0px 20px 20px 20px' }}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          console.log('Formik onSubmit triggered');
          console.log('Submitted values:', values);
          await onSubmit(values);
        }}
        enableReinitialize>
        {({ handleSubmit, errors, touched }) => (
          <Form onSubmit={handleSubmit}>
            <Field
              name="name"
              as={TextField}
              label="Name"
              fullWidth
              margin="normal"
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
            <Field
              name="description"
              as={TextField}
              label="Description"
              multiline
              rows={4}
              fullWidth
              margin="normal"
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                marginTop: 2,
              }}>
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                onClick={onClose}
                sx={{ marginRight: 1 }}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="secondary">
                Done
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </DialogContent>
  </Dialog>
);

export default CatalogueDialog;
